import React from 'react'
import OrderDetailContainer from 'containers/panel/subreseller/order-detail-container'


const OrderDetailPage = () => {
  return (
    <OrderDetailContainer/>
  )
}

export default OrderDetailPage